<template>
  <div class="alarmlog">
    <div class="alarmlog-m">
      <el-form
        :inline="true"
        :model="formsubmit"
        @keyup.enter.native.prevent="enterSearchMember(formsubmit)"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item>
          <el-date-picker
            :editable="false"
            v-model="formsubmit.timevalue"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formsubmit.alertType"
            clearable
            placeholder="请选择告警类型"
            style="width:140px"
            filterable
          >
            <el-option
              v-for="(item, index) in alertTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
       
        <el-form-item>
          <el-select
            v-model="formsubmit.isHandle"
            clearable
            placeholder="是否处理"
            style="width:110px"
            filterable
          >
            <el-option
              v-for="(item, index) in isHandleList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="formsubmit.oldmanName"
            placeholder="老人姓名"
            style="width:130px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="formsubmit.inputdeviceno"
            placeholder="设备编号"
            style="width:130px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click.native.prevent="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="danger" icon="el-icon-delete" @click="onClear"
            >清空选择</el-button
          >
        </el-form-item> -->
        <el-form-item>
          <el-button
              type="info"
              @click="downAlert"
              icon="el-icon-download"
              plain
              >导出</el-button
            >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-zoom-out"
            @click="batchHandle"
            plain
            :disabled="disabledLook"
            >批量处理</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            icon="el-icon-delete"
            plain
            @click="batchDelete"
            :disabled="disabledDelete"
            >批量删除</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            icon="el-icon-finished"
            plain
            @click="handleAll"
            >全部处理</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-zoom-out"
            plain
            @click="batchRead"
            :disabled="disabledLook"
            >批量查看</el-button
          >
        </el-form-item> -->
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          v-loading="loading"
          :data="list"
          style="width: 100%"
          ref="alarmlogTable"
          :row-key="getRowKey"
           :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          @selection-change="selsChange"
          highlight-current-row
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column
            label="设备编号"
            width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 2px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="报警类型"
            min-width="100"
            align="center"
            :formatter="formatType"
            :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            label="报警信息"
            align="center"
            min-width="170"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.alertInfo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="老人姓名"
            align="center"
            min-width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.oldmanName && scope.row.oldmanName != ' '"
                >{{ scope.row.oldmanName }}</span
              >
              <span style="color: red" v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column
            label="处理结果"
            align="center"
            min-width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.handleRemark">{{
                scope.row.handleRemark
              }}</span>
              <span style="color: red" v-else>无描述</span>
            </template>
          </el-table-column>
          <el-table-column
            label="时间"
            align="center"
            min-width="140"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createdTime }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="处理人"
            width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.alertType }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="处理状态"
            align="center"
            width="90"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-col v-if="scope.row.handleStatus == 0" style="color: red"
                >未完成</el-col
              >
              <el-col v-if="scope.row.handleStatus == 1" style="color: green"
                >已完成</el-col
              >
              <el-col v-if="scope.row.handleStatus == 2">其他</el-col>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                :disabled="!disabledDeal"
                v-if="scope.row.handleStatus == 1"
                plain
                @click="handleDeal(scope.$index, scope.row)"
                >处理完</el-button
              >
              <el-button
                type="warning"
                size="mini"
                :disabled="disabledDeal"
                plain
                v-else
                @click="handleDeal(scope.$index, scope.row)"
                >待处理</el-button
              >
              <!-- <el-button
                type="primary"
                size="mini"
                plain
                v-if="scope.row.isRead == false"
                @click="handleLook(scope.$index, scope.row)"
                >待查看</el-button
              > -->
              <!-- <el-button
                type="success"
                size="mini"
                plain
                v-if="scope.row.isRead == true"
                disabled="disabled"
                >已查看</el-button
              > -->
              <el-button
                type="danger"
                size="mini"
                plain
                :disabled="
                  !(scope.row.handleStatus == 1 && scope.row.isRead == true)
                "
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>

    <!-- 弹出处理报警记录dialog -->
    <el-dialog
      title="处理报警记录"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="dealalarm"
      @close="closeDealAlarm"
    >
      <el-form ref="form" :model="form" :rules="rules">
        <!-- <el-form-item label="报警Id :" :label-width="formLabelWidth">
                    <span>{{form.id}}</span>
        </el-form-item>-->
        <el-form-item
          label="处理状态 :"
          :label-width="formLabelWidth"
          prop="handleStatus"
        >
          <el-radio-group v-model="form.handleStatus">
            <el-radio :label="0">未完成</el-radio>
            <el-radio :label="1">已完成</el-radio>
            <el-radio :label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="处理结果描述 :"
          :label-width="formLabelWidth"
          prop="handleRemark"
        >
          <el-input
            v-model.trim="form.handleRemark"
            type="textarea"
            :rows="3"
            placeholder="请输入处理结果描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="cancelDealAlarm">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { baseURL } from "@/utils/request.js";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      isBatchHandle: false,
      websock: null,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      sels: [], //列表选中列的checkbox集合
      disabledDelete: true, //批量删除默认是不可点击的
      disabledLook: true, //批量查看默认是不可点击的
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      videoDialogVisible: false,
      activeName:"one",
      disabledDeal: false,
      //紧急呼叫报警类 0 默认-告警  28 紧急呼叫报警 35 院内紧急呼叫报警
      
      //定位报警类  1 进出围栏告警  
      
      //安防报警类 31 红外探测器告警 32 烟雾报警器告警 33 燃气泄漏告警 34 溢水告警 35 门磁感应器告警

      //体征报警类  18 心率呼吸报警 44 跌倒报警 45 体温偏高 

      //其他 50 设备离线告警 51 离床报警 52 久坐提醒  53 夜间巡视告警
      alertTypeList: [
        //报警类型
        {
          value: "0",
          label: "紧急呼叫告警",
        },
        {
          value: "1",
          label: "进出围栏告警",
        },
        {
          value: "7",
          label: "呼吸停止告警",
        },
        {
          value: "10",
          label: "设备离线告警",
        },
        {
          value: "11",
          label: "离床告警",
        },
        {
          value: "12",
          label: "温湿度异常告警",
        },
        {
          value: "18",
          label: "呼吸心跳异常",
        },
        {
          value: "19",
          label: "体温异常告警",
        },
        {
          value: "20",
          label: "夜间巡视告警",
        },
        {
          value: "27",
          label: "红外探测器告警",
        },
        {
          value: "28",
          label: "紧急呼叫告警",
        },
        {
          value: "29",
          label: "烟雾报警器告警",
        },
        {
          value: "30",
          label: "燃气泄漏告警",
        },
        {
          value: "31",
          label: "溢水告警",
        },
        {
          value: "32",
          label: "门磁感应器告警",
        },
        {
          value: "44",
          label: "老人跌倒告警",
        },
        {
          value: "45",
          label: "紧急呼叫告警",
        },
        {
          value: "53",
          label: "老人跌倒告警",
        }
      ],
      isReadList: [
        //是否查看
        {
          value: "0",
          label: "待查看",
        },
        {
          value: "1",
          label: "已查看",
        },
      ],
      isHandleList: [
        //是否处理
        {
          value: "0",
          label: "待处理",
        },
        {
          value: "1",
          label: "已处理",
        },
      ],
      handleStatusList: [
        //处理状态
        {
          value: "0",
          label: "未完成",
        },
        {
          value: "1",
          label: "已完成",
        },
        {
          value: "2",
          label: "其他",
        },
      ],
      //查询传入的参数
      formsubmit: {
        timevalue: "",
        alertType: "",
        oldmanName:"",
        isRead: "",
        isHandle: "",
        handleStatus: "",
        inputdeviceno: "",
      },

      // 处理报警记录dialog
      dialogFormVisible: false,
      form: {
        id: "",
        handleStatus: 1,
        handleRemark: "",
      },
      formLabelWidth: "120px",
      rules: {
        //处理报警记录的正则验证
        handleStatus: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        handleRemark: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '请输入由数字或者字母或者中文组成的字符' }
        ],
      },
      //element-ui 日期选择器如何限制只能选择一个月，超过一个月不能选择，也就是在选定起始日期时，只能向后面选择30天，同时不能选择超过今天的日期
      pickerMinDate: "",
      dateRange: [],
      pickerOptions: {
        //2种
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      flashFlag: true, //flash默认是关闭的--true
      videoObjectPc: {
        width: 1015, // 宽度，也可以支持百分比(不过父元素宽度要有)
        height: 574, // 高度，也可以支持百分比
        container: "#video", //“#”代表容器的ID，“.”或“”代表容器的class
        variable: "player", //该属性必需设置，值等于下面的new chplayer()的对象
        autoplay: true, //自动播放
        live: true,
        video: "", //视频地址 rtmp://58.200.131.2:1935/livetv/hunantv
      },
    };
  },
  methods: {
    //by guo 2019-11-20-16:00添加
    //保存选中的数据id,row-key就是要指定一个key标识这一行的数据
    getRowKey(row) {
      return row.id;
    },
    //选中行
    handleSelectionChange(val) {
    },
    //清空 重置选取的值
    onClear() {
      this.formsubmit = {
        timevalue: "",
        alertType: "",
        isRead: "",
        oldmanName:"",
        isHandle: "",
        handleStatus: "",
        inputdeviceno: "",
      };
      this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
    },
    formatType(row){
      let type = '其他报警';
      this.alertTypeList.forEach(item =>{
        if(item.value == ''+row.alertType){
          type = item.label;
        }
      })
      return type;
    },
    onSubmit() {
      if (this.formsubmit.inputdeviceno == "") {
        this.getTableData(this.formsubmit.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formsubmit.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(formsubmit) {
      this.getTableData();
    },

    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
       return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    //关闭处理报警dialog的回调
    closeDealAlarm() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警取消按钮
    cancelDealAlarm() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //处理报警记录 弹出dialog框
    handleDeal(index, row) {
      console.log(index, row);
      this.form = Object.assign({}, row);
      console.log(this.form);
      this.dialogFormVisible = true;
      this.isBatchHandle = false;
    },

    //处理报警记录提交数据
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            id: this.form.id,
            handleStatus: this.form.handleStatus,
            handleRemark: this.form.handleRemark,
          };
          let idList = [];
          this.sels.forEach((item) => {
            idList.push(item.id);
          });
          let param1 = {
            idList: idList,
            handleStatus: this.form.handleStatus,
            handleRemark: this.form.handleRemark,
          };
          this.$postJson(
            !this.isBatchHandle
              ? "dmc/alert/handleDeviceAlert"
              : "dmc/alert/batchHandleByIdList",
            !this.isBatchHandle ? param : param1
          ).then((res) => {
            console.log(res);
            this.dialogFormVisible = false;
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.getTableData();
            bus.$emit("homePage", { type: "alartMsgChange" });
            this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
          });
        } else {
          console.log("处理报警记录失败");
          return false;
        }
      });
    },

    //查看报警记录
    handleLook(index, row) {
      console.log(index, row);
      console.log(row.id);
      let id = row.id;
      this.$postForm("dmc/alert/readById/" + id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
        this.getTableData();
        this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
      });
    },

    //批量处理
    batchHandle() {
      (this.form = {
        id: "",
        handleStatus: 1,
        handleRemark: "已处理",
      }),
        (this.isBatchHandle = true);
      var idList = [];
      var flag = false;
      // let isDeal = [];
      this.sels.forEach((item, index) => {
        if (item.handleStatus == 1) {
          // isDeal.push("true");
          // return (flag = false);
        } else {
          flag = true;
          idList.push(item.id * 1);
        }
      });
      // if (isDeal.length > 0) {
      //   this.$message({
      //     message: "选取的已经有被处理的",
      //     type: "error",
      //   });
      // }
      if (flag) {
        this.$confirm("确定要批量处理报警记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            this.dialogFormVisible = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消批量处理",
            });
          });
      }
    },

    //批量查看
    batchRead() {
      var idList = [];
      var flag = true;
      let isReadList = [];
      this.sels.forEach((item, index) => {
        if (item.isRead == true) {
          isReadList.push("true");
          return (flag = false);
        }
      });
      if (isReadList.length > 0) {
        this.$message({
          message: "选取的已经有被查看的",
          type: "error",
        });
      } else {
        this.sels.forEach((element, index) => {
          idList.push(element.id * 1);
          this.$confirm("确定要批量查看报警记录吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
            closeOnClickModal: false,
          })
            .then(() => {
              this.loading = true;
              let param = {
                idList: idList,
              };
              console.log(param);
              this.$postJson("dmc/alert/batchReadByIdList", param).then(
                (res) => {
                  this.loading = false;
                  if (res.code == 200) {
                    this.$message({
                      message: res.message,
                      type: "success",
                    });
                  } else {
                    this.$message({
                      message: res.message,
                      type: "error",
                    });
                  }
                  this.getTableData();
                  this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消批量查看",
              });
            });
          console.log(idList);
          console.log(flag);
        });
      }
    },

    //删除报警记录
    handleDelete(index, row) {
      console.log(index, row);
      console.log(row.id);
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        ancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          console.log(row.id);
          let id = row.id;
          this.$postForm("dmc/alert/deleteById/" + id).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.getTableData();
            this.$bus.$emit("handleDeletechange_One"); //发送一个change事件 去改变报警的铃铛图片的数据
            this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    //选择的勾选的列
    selsChange: function (sels) {
      this.sels = sels;
      console.log(sels);
      //三元运算符  当选取的值大于0时 批量删除可以点击 否则不可点击
      this.sels.length > 0
        ? (this.disabledDelete = false)
        : (this.disabledDelete = true);
      //三元运算符  当选取的值大于0时 并且所选取的列的报警记录没有被查看  批量查看才可以点击 否则不可点击
      this.sels.length > 0
        ? (this.disabledLook = false)
        : (this.disabledLook = true);
    },
    //批量删除
    batchDelete() {
      var idList = [];
      var flag = true;
      console.log(this.sels, "-----");
      this.sels.forEach((item, index) => {
        //by guo 2019-11-20-14:56修改  handleStatus==1  处理已完成的
        // if (item.isRead == false || item.isHandle == false) {
        if (
          item.isRead == false ||
          item.isHandle == false ||
          item.handleStatus == 0 ||
          item.handleStatus == 2
        ) {
          //by guo 2019-11-12-18:54注释
          // this.$message({
          //   message: "选取的存在待处理或者待查看的",
          //   type: "error"
          // });
          return (flag = false);
        } else {
          idList.push(item.id * 1);
        }
      });
      console.log(idList);
      console.log(flag);
      if (flag) {
        this.$confirm("确定要批量删除报警记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            this.loading = true;
            let param = {
              idList: idList,
            };
            console.log(param);
            this.$postJson("dmc/alert/batchDeleteByIdList", param).then(
              (res) => {
                this.loading = false;
                if (res.code == 200) {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }
                this.getTableData();
                this.$bus.$emit("handleDeletechange_All"); //发送一个change事件 去改变报警的铃铛图片的数据
                this.$refs.alarmlogTable.clearSelection(); //清空表格checkbox选择的值  by guo 2019-11-20-16:00 添加
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消批量删除",
            });
          });
      } else {
        //by guo 2019-11-12-18:52添加
        this.$message({
          message: "选取的存在待处理或者待查看的",
          type: "error",
        });
      }
    },
    handleAll() {
      this.$prompt('请输入处理结果描述', '全部处理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入处理结果描述',
        inputValidator: (val) => val && val.trim().length > 0 ? true : '处理结果描述不能为空',
      }).then(({ value }) => {
        let param = {
          pageNum: 1,
          pageSize: 9999,
          oldmanName: this.formsubmit.oldmanName,
          alertType: this.formsubmit.alertType !== '' ? this.formsubmit.alertType * 1 : '',
          isHandle: 0,
          deviceNo: this.formsubmit.inputdeviceno,
        };
        if (this.formsubmit.timevalue) {
          param['startQueryTime'] = this.formsubmit.timevalue[0];
          param['endQueryTime'] = this.formsubmit.timevalue[1].substring(0, 10) + ' 23:59:59';
        }
        this.$postJson('dmc/alert/queryDeviceAlertListWithPage', param).then((res) => {
          if (res.code == 200 && res.result && res.result.list && res.result.list.length > 0) {
            const idList = res.result.list.map(item => item.id * 1);
            this.$postJson('dmc/alert/batchHandleByIdList', {
              idList,
              handleStatus: 1,
              handleRemark: value.trim(),
            }).then((res2) => {
              if (res2.code == 200) {
                this.$message({ type: 'success', message: '已处理 ' + idList.length + ' 条记录' });
                this.getTableData();
                bus.$emit('homePage', { type: 'alartMsgChange' });
              } else {
                this.$message({ type: 'error', message: res2.message || '处理失败' });
              }
            });
          } else {
            this.$message({ type: 'info', message: '没有待处理的记录' });
          }
        });
      }).catch(() => {});
    },
    downAlert(){
      this.$confirm("确定要下载报警记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          var url = "";
          if (this.formsubmit.alertType) {
            url = url + "&alertType=" + this.formsubmit.alertType;
          }
          if (this.formsubmit.timevalue) {
            let startQueryTime  = this.formsubmit.timevalue[0].substring(0, 10) + " 00:00:00";
            let endQueryTime = this.formsubmit.timevalue[1].substring(0, 10) + " 23:59:59";
            url = url +
                "&startQueryTime=" + startQueryTime +
                "&endQueryTime=" +endQueryTime;
          }
          if (this.formsubmit.isRead) {
            url = url + "&isRead=" + this.formsubmit.isRead;
          }
          if (this.formsubmit.isHandle) {
            url = url + "&isHandle=" + this.formsubmit.isHandle;
          }
          if (this.formsubmit.handleStatus) {
            url = url + "&handleStatus=" + this.formsubmit.handleStatus;
          }
          if (this.formsubmit.inputdeviceno) {
            url = url + "&deviceNo=" + this.formsubmit.inputdeviceno;
          }
          window.location.href =
            baseURL +
            "dmc/api/downDeviceAlert?groupId="+sessionStorage.getItem("groupId") +  url;
        });
    },
    //获取报警记录 分页列表
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName:this.formsubmit.oldmanName,
        alertType:
          this.formsubmit.alertType != "" ? this.formsubmit.alertType * 1 : "",
        isRead: this.formsubmit.isRead != "" ? this.formsubmit.isRead * 1 : "",
        isHandle:
          this.formsubmit.isHandle != "" ? this.formsubmit.isHandle * 1 : "",
        handleStatus:
          this.formsubmit.handleStatus != ""
            ? this.formsubmit.handleStatus * 1
            : "",
        deviceNo: this.formsubmit.inputdeviceno,
      };
      if (this.formsubmit.timevalue) {
        param["startQueryTime"] = this.formsubmit.timevalue[0];
        param["endQueryTime"] =
          this.formsubmit.timevalue[1].substring(0, 10) + " 23:59:59";
      } else {
      }
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/alert/queryDeviceAlertListWithPage", param).then(
        (res) => {
          console.log(res);
          //在请求成功后把document.onkeydown置为undefined
          document.onkeydown = undefined;
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },
  watch: {
    currentPage(oldV, newV) {
      console.log(oldV, newV);
    },
  },
  created() {
    //监听父Home页组件websocket的数据变化 
    this.$bus.$on("changeHome_alarmLog", () => {
      this.getTableData();
    });
    // 此时 data 已经被 observed 了
    this.getTableData();
    //键盘事件 查询
    var _self = this;
    document.onkeydown = function (e) {
      if (window.event == undefined) {
        var key = e.keyCode;
      } else {
        var key = window.event.keyCode;
      }
      if (key == 13) {
        _self.enterSearchMember("formsubmit");
      }
    };
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.alarmlog {
  .alarmlog-m {
    padding: 10px 0 0 5px;
  }
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//处理报警记录的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dealalarm .el-dialog {
    width: 30% !important;
  }
}

#video {
  width: 100%;
  height: 420px;
}
</style>


